import { updateActionErrors } from './updateErrors';
import {
    ADD_TEAM_MEMBER, UPDATE_TEAM_MEMBER, DELETE_TEAM_MEMBER, FETCH_TEAM
} from '../actions/actionTypes';
import graphqlClient from '../../api/axios_interceptor';
import { AddTeamMemberMutation, DeleteTeamMemberMutation, GetTeamQuery, UpdateTeamMemberMutation } from '../../api/graphql/queries/team';


const applyReduxStorageFormat = (result) => {
    let person = {};
    let personList = [];

    result.map((member) => {
        person[member.user.id] = {
            username: member.user.username,
            memberId: member.id,
            firstName: member.user.firstName,
            lastName: member.user.lastName,
            email: member.user.email,
            isAdmin: member.isAdmin,
            phoneNumber: member.user.phoneNumber,
            personId: member.user.id,
            customerAccountId: member.customerAccount? member.customerAccount.id : "",
            role: member.role.toLowerCase(),
            propertyIds: member.propertyIds || [],
            userPermissions: member.userPerms
        }
        
    });
    // return a list of person objects which includes teamMember objects as one of the fields
    personList = Object.values(person);

    return personList;
}


const teamMiddleware = storeAPI => next => async action => {
    let teamMember = action.payload;

    switch (action.type) {
        case ADD_TEAM_MEMBER:
            try {
                await graphqlClient({
                    data: {
                        query: AddTeamMemberMutation(
                            teamMember
                        )
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else if (queryResult.data.data.addTeamMember.errors){
                        action = updateActionErrors(action, queryResult.data.data.addTeamMember.errors);
                    }
                    else {
                        let result = queryResult.data.data.addTeamMember.teamMember;
                        let personList = applyReduxStorageFormat([result]);
                        action = {
                            ...action,
                            payload: personList[0]
                        };
                    }

                });

            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }

            break;

        case UPDATE_TEAM_MEMBER:
            try {
                const query = UpdateTeamMemberMutation(
                    teamMember
                )
                await graphqlClient({
                    data: { query }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else if (queryResult.data.data.updateTeamMember.errors){
                        action = updateActionErrors(action, queryResult.data.data.updateTeamMember.errors);
                    }
                    else {
                        let result = queryResult.data.data.updateTeamMember.teamMember;
                        let personList = applyReduxStorageFormat([result]);
                        action = {
                            ...action,
                            payload: personList[0]
                        };
                    }
                })
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }

            break;

        case DELETE_TEAM_MEMBER:

            try {

                await graphqlClient({
                    data: {
                        query: DeleteTeamMemberMutation(teamMember.personId)
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    }else if(queryResult.data.data.deleteTeamMember.errors){
                        action = updateActionErrors(action, queryResult.data.data.deleteTeamMember.errors);
                    }
                });
            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error);
            }

            break;

        case FETCH_TEAM:
            try {
                await graphqlClient({
                    data: {
                        query: GetTeamQuery()
                    }
                }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else {
                        let person = {};
                        let result = queryResult.data.data.allTeamMembersUsingList;
                        let personList = applyReduxStorageFormat(result);
                        personList.map((member) => {
                            person[member.personId] = { ...member }
                        })
                        let initialData = { person };
                        action = {
                            ...action,
                            payload: initialData
                        };
                    }
                })
            } catch (error) {
                console.error(error);
            }

            break;
    }
    return next(action);
};

export {
    teamMiddleware
}